export default __webpack_public_path__ + "assets/images/07ff452053c4fdf5e4af746db4b5ea26.png";